import { Spacing, SpeedDial, Stack, styled } from 'ui';

export const StyledHeader = styled(Stack)`
  position: fixed;
  padding: ${({ theme }) => theme.spacing(Spacing.Medium)};
  padding-left: 86px;
  height: 88px;
  background: ${({ theme }) => theme.palette.paper[200]};
  box-shadow: ${({ theme }) => theme.boxShadows.card};
  z-index: 1000;
  color: ${({ theme }) => theme.palette.text.primary};
  width: 100%;
  margin-top: 56px;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
`;

export const SpeedDialWrapper = styled(SpeedDial)`
  position: fixed;
  bottom: 5%;
  right: 5%;
  z-index: 9999;
`;
